<template>
  <div class="leftres">
    <div>
      <div class="inputtop">
        <template v-for="(item , index) of formdata">
          <Commondropdownlist  :key="index" ref="selectinput" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </template>
        <CommonBtngroup :qhide="false" :show="false" @select="select" @reset="reset" style="margin-right: 120px;margin-top: 15px;"></CommonBtngroup>
      </div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px;background-color: #FFFFFF;">
        <Permissionlisttable :tableData="tableData" :total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Permissionlisttable>
      </div>
      <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK" :src="require('@/assets/icon/icon-errors.png')">
        <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
      </Dialog>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../components/commongroup.vue'
import Dialog from '../../components/dialog.vue'
import Permissionlisttable from './components/permissionlisttable.vue'
import {
  AuthorityLists,
} from '@/api/home.js'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    Dialog,
    Permissionlisttable
  },
  data() {
    return {
      username: '',
      name: '',
      dialogVisibles: false,
      tableData: [],
      total: 0,
      pageSize: 20,
      pageIndex: 1,
      authorityCode: '',
      authorityName: '',
      formdata: [
        {
          inputdata: '',
          title: '权限名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '220px'
        },
        {
          inputdata: '',
          title: '权限编码',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '220px'
        },
      ]
    }
  },
  mounted() {
    this.authorityLists()
  },
  methods: {
    //查询boxslist列表
    async authorityLists() {
      let boxslist = await AuthorityLists({
        authorityCode: this.authorityCode,
        authorityName: this.authorityName,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
  
      if (boxslist.code == 0) {
        this.total = boxslist.data.count
        this.tableData = boxslist.data.data
      }
      //console.log('boxslist', this.tableData)
    },
    // 重置
    reset() {
      this.$refs.selectinput.map((item, index) => {
        item.modelvalue = ''
      })
      // this.dialogVisibles = true
    },
    // 搜索
    select() {
      this.pageIndex = 1
      let e = this.$refs.selectinput
      this.authorityName = e[0].modelvalue
      this.authorityCode = e[1].modelvalue
      this.authorityLists()
    },
    cancel() {
      //console.log('name')
      this.dialogVisibles = false
    },
    dialogOK() {
      //console.log('name2')
      this.dialogVisibles = false
    },
    handleCurrentChange(pageindex) {
      this.pageIndex = pageindex
      this.authorityLists()
      //console.log(this.pageIndex, 'pageindex')
    },
    handleSizeChange(paegSzie) {
      this.pageSize = paegSzie
      this.authorityLists()

    },

  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 24px;
}
</style>